module.exports = __webpack_public_path__ + "img/platform3.0d872e94.png";